import React, { FC, ReactNode, useState } from 'react';
import { LicenseContextType, LicenseContext } from './LicenseContext';

export const LicenseProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentLicenseKey, setCurrentLicenseKey] = useState<string | undefined>();
  const [daysUntilLicenseExpires, setDaysUntilLicenseExpires] = useState<number | undefined>();
  const [isLicenseExpired, setIsLicenseExpired] = useState(false);
  const [isLicenseAboutExpiredModal, setIsLicenseAboutExpiredModal] = useState(false);

  const updateLicenseData = (
    currentLicenseKey: string,
    daysUntilLicenseExpires: number,
    _isLicenseExpired: boolean
  ) => {
    setCurrentLicenseKey(currentLicenseKey);
    setDaysUntilLicenseExpires(daysUntilLicenseExpires);
    // Проверка лицензии отключена — не блокируем UI
    setIsLicenseExpired(false);
    setIsLicenseAboutExpiredModal(false);
  };

  const setLicenseExpired = (currentLicenseKey: string, _isLicenseExpired: boolean) => {
    setCurrentLicenseKey(currentLicenseKey);
    setIsLicenseExpired(false);
  };

  const resetLicenseAboutExpiredModal = () => {
    setIsLicenseAboutExpiredModal(false);
  };

  const contextValues: LicenseContextType = {
    currentLicenseKey,
    daysUntilLicenseExpires,
    isLicenseExpired,
    isLicenseAboutExpiredModal,
    updateLicenseData,
    setLicenseExpired,
    resetLicenseAboutExpiredModal
  };

  return <LicenseContext.Provider value={contextValues}>{children}</LicenseContext.Provider>;
};
